module.exports = __webpack_public_path__ + "img/aldar.1322124.webp";